var map = {
	"./announcement/announcement.module": "./src/app/main/announcement/announcement.module.ts",
	"./dashboard/dashboard.module": "./src/app/main/dashboard/dashboard.module.ts",
	"./event/event.module": "./src/app/main/event/event.module.ts",
	"./home/home.module": "./src/app/main/home/home.module.ts",
	"./main/main.module": "./src/app/main/main.module.ts",
	"./shop/shop.module": "./src/app/main/shop/shop.module.ts",
	"./user/user.module": "./src/app/main/user/user.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;